
import React, { PropTypes } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import { PODLASKIE_MODE } from '../../constants'
import { portalMode } from '../../config';


const ModalAlert = ({ title, bodyText, disableButton, noCloseButton, name, ...props }) =>
<Modal {...props}>
  <Modal.Header className="bg-warning" closeButton={!noCloseButton}>
    <Modal.Title>{title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {bodyText}
    <br /><br />
    {!disableButton ? (
      <Button className={"btn btn-primary pull-right"} style={{ color: 'white' }} onClick={() => props.onHide(name)}>Zamknij</Button>
    ) : null}
    <br /><br />
  </Modal.Body>
  </Modal>;

export default ModalAlert;


// WEBPACK FOOTER //
// src/routes/eservices/ModalAlert.js